export const auxiliaryFxs = () => {

    const handleSelectedDate = (evt,setSelectedDate) => {
        setSelectedDate(evt);
    }

    return {
        handleSelectedDate
    }
}